export const HOME_ROUTE = '/';
export const AUTH_ROUTE = '/auth';
export const LOGIN_ROUTE = `${AUTH_ROUTE}/login`;
export const SIGNUP_ROUTE = `${AUTH_ROUTE}/sign-up`;
export const FORGOT_PASSWORD = `${AUTH_ROUTE}/forgot-password`;
export const RESET_PASSWORD = `${AUTH_ROUTE}/reset-password`;
export const INVITE_CREATE_PASSWORD = `${AUTH_ROUTE}/create-password`;

export const ACCOUNT_ROUTE = '/account';
export const ACCOUNT_SETTINGS_ROUTE = `${ACCOUNT_ROUTE}/settings`;

export const DASHBOARD_ROUTE = '/dashboard';

export const ROUNDS_ROUTE = '/rounds';

export const TEAMS_ROUTE = '/account/teams';
export const COURSES_ROUTE = '/account/courses';
export const PLAN_ROUTE = '/account/subscription-plan';
export const SUBSCRIBE_ROUTE = '/subscribe';
export const DEMO_ROUTE = '/demo';
export const BLOG_ROUTE = '/blog';
export const PRICING_ROUTE = '/pricing';

export const PRIVACY_POLICY_ROUTE = '/privacy-policy';
export const TERMS_AND_CONDITIONS_ROUTE = '/terms-and-conditions';

export const ADMIN_ROUTE = '/nimda';

export function getTeamsRoute({ teamId }: { teamId: number }) {
    return `${TEAMS_ROUTE}/${teamId}`;
}

export function getRoundRoute({ roundId }: { roundId: number }) {
    return `${ROUNDS_ROUTE}/${roundId}`;
}

export function getRoundHoleRoute({ roundId, holeNumber }: { roundId: number; holeNumber: number }) {
    return `${ROUNDS_ROUTE}/${roundId}/hole/${holeNumber}`;
}
